@if (getView(); as view) {
    <div class="PGFilePreview PGFilePreview--{{view.toUpperCase()}} bg-light">
        <div class="PGFilePreview-Text px-2">
            <div class="PGFilePreview-Text-Name">
                <a target="_blank" [href]="file.url | safe:'url'" title="{{file.nome}}">{{file.nome}}</a>&nbsp;
            </div>
            @if (info && info.path) {
                <div class="PGFilePreview-Text-Path">
                    <small class="text-muted" title="{{info.path}}">{{info.path}}</small>
                </div>
            }
            @if (getAuthorSourceLicense(); as authorSourceLicense) {
                <small class="PGFilePreview-Text-AuthorSourceLicense text-muted" [innerHTML]="authorSourceLicense"></small>
            }
        </div>
        <figure class="PGFilePreview-Figure m-0">
            <div class="PGFilePreview-Display">
                @if (view == 'images') {
                    <app-pg-image-autosize [src]="file.url" fit="cover" (success)="onLoadSuccess()" (error)="onLoadError()"></app-pg-image-autosize>
                }
                @if (view == 'audios') {
                    <audio class="PGFilePreview-Display-Media {{getMediaPreviewClass()}}" controls controlsList="nodownload" (canplaythrough)="onLoadSuccess()">
                        <source [src]="file.url | safe:'url'" type="audio/mpeg" (error)="onLoadError()">
                    </audio>
                }
                @if (view == 'videos') {
                    <video class="PGFilePreview-Display-Media {{getMediaPreviewClass()}}" controls controlsList="nodownload" (canplaythrough)="onLoadSuccess()">
                        <source [src]="file.url | safe:'url'" type="video/mp4" (error)="onLoadError()">
                    </video>
                }
                @if (view == 'files') {
                    @if (getFileSmallPreview(); as preview) {
                        <div class="PGFilePreview-Display-SmallPreview  PGFilePreview-Display-SmallPreview--{{preview.toUpperCase()}} {{getMediaPreviewClass()}}" (click)="openPreviewModal(preview)">
                            @if (preview == 'images') {
                                <div>
                                    <i class="fa-regular fa-search"></i>
                                    <app-pg-image-autosize [src]="file.url" fit="cover" (success)="onLoadSuccess()" (error)="onLoadError()"></app-pg-image-autosize>
                                </div>
                            }
                            @if (preview == 'audios') {
                                <div class="bg-dark">
                                    <i class="fa-regular fa-play"></i>
                                    <audio (canplaythrough)="onLoadSuccess()">
                                        <source [src]="file.url | safe:'url'" type="audio/mpeg" (error)="onLoadError()">
                                    </audio>
                                </div>
                            }
                            @if (preview == 'videos') {
                                <div>
                                    <i class="fa-regular fa-play"></i>
                                    <video (canplaythrough)="onLoadSuccess()">
                                        <source [src]="file.url | safe:'url'" type="video/mp4" (error)="onLoadError()">
                                    </video>
                                </div>
                            }
                        </div>
                    }
                    @if (!getFileSmallPreview()) {
                        <i class="{{file.icon}}"></i>
                    }
                }
                @if (hasError) {
                    <div class="PGFilePreview-Display-Error pg-animation-fadein">
                        <i class="fa-regular fa-exclamation-triangle text-danger pg-animation-shake"></i>
                    </div>
                }
            </div>
            @if (file.caption?.trim(); as caption) {
                <figcaption class="PGFilePreview-Caption my-1 px-2 text-muted text-center small" [title]="caption">{{ caption }}</figcaption>
            }
        </figure>
    </div>
}

<ng-template #previewModal>
    <div class="modal-header">
        <h5 class="modal-title">{{file.nome}}</h5>
        <button type="button" class="modal-close btn btn-link" (click)="previewModalDismiss()">
            <i class="fa-regular fa-times"></i>
        </button>
    </div>
    <div class="modal-body">
        @if (previewMode) {
            <div class="PGFilePreview-Display-SmallPreview-FullScreen">
                @if (isLoadingPreview) {
                    <app-pg-loading></app-pg-loading>
                }
                <div class="PGFilePreview-Display-SmallPreview-FullScreen-Main {{!isLoadingPreview ? 'PGFilePreview-Display-SmallPreview-FullScreen-Main--Loaded' : ''}}">
                    @if (previewMode == 'images') {
                        <img [src]="file.url | safe:'url'" (load)="isLoadingPreview = false" (error)="isLoadingPreview = false">
                    }
                    @if (previewMode == 'audios') {
                        <audio controls controlsList="nodownload" (canplaythrough)="isLoadingPreview = false">
                            <source [src]="file.url | safe:'url'" type="audio/mpeg" (error)="isLoadingPreview = false">
                        </audio>
                    }
                    @if (previewMode == 'videos') {
                        <video controls controlsList="nodownload" (canplaythrough)="isLoadingPreview = false">
                            <source [src]="file.url | safe:'url'" type="video/mp4" (error)="isLoadingPreview = false">
                        </video>
                    }
                </div>
            </div>
        }
    </div>
</ng-template>
